// posts/CincinnatiBreweries.jsx
import React from "react";
import "../../../css/BlogArticle.css";

export default function CincinnatiBreweries() {
  return (
    <div className="blog-article">
      <div className="blog-callout">
        <strong>Quick take:</strong> A short hop across the river gets you some
        seriously good Cincinnati breweries — perfect for St. Patty’s season and
        spring weekends.
      </div>

      <p>
        I know I am a Kentucky girl… BUT right across the river are some amazing
        Breweries. If you are up for a short trip, you have to visit these!
      </p>

      <p>
        I love our Cincinnati breweries, and with St. Patty’s day just around
        the corner (and Spring! Yay!), it’s a great time to think about new
        places to go. Whether it’s green beer day or any other ordinary day, we
        have some incredible spots in the area to go enjoy a cold one. Here are
        four of my favorites to check out!
      </p>

      <h2>1. Little Miami Brewery</h2>
      <p>
        Every year my family does a kayak tour on the Little Miami river. It is
        the most beautiful scenery on the river with great places to swim. We
        stop halfway and pull the kayaks to shore, then walk up the hill to
        Little Miami Brewery. Along with being much-needed break from paddling,
        you get to enjoy carb-loading for the next leg of your journey with
        their yummy brick oven pizza and wide selection of brews.
      </p>

      {/* Replace src with your local asset */}
      <figure className="blog-figure">
        <img
          src="/imgs/blog/breweries/little-miami.png"
          alt="Beer at the Little Miami Brewing Company"
          loading="lazy"
        />
        <figcaption className="blog-figcaption">
          Beer at the Little Miami Brewing Company{" "}
          <span className="blog-credit">• Photo: @littlemiamibrew on Instagram</span>
        </figcaption>
      </figure>

      <h2>2. Fifty West Brewing Company</h2>
      <p>
        Who knew you could find beach sand in Ohio? Fifty West has everything
        you need to feel like a chill day at the beach: cornhole, sand
        volleyball, space for the kids to build sand castles. It’s an easy stop
        off the Loveland bike trail, so my family goes here a few times a year
        for a quick bite. Our family favorite is the cheeseburger and fries, and
        of course, the draft beers!
      </p>

      <figure className="blog-figure">
        <img
          src="/imgs/blog/breweries/fifty-west.png"
          alt="Drink offerings on the volleyball court at Fifty West Brewing Company"
          loading="lazy"
        />
        <figcaption className="blog-figcaption">
          Drink offerings at Fifty West{" "}
          <span className="blog-credit">• Photo: @fiftywestbrew on Instagram</span>
        </figcaption>
      </figure>

      <h2>3. Taft’s Ale House</h2>
      <p>
        Whether you’re spending the day downtown, visiting Washington park, or
        just in the neighborhood, head over to Taft’s Ale House in OTR. This
        unique venue used to be an old church and is a gorgeous setting for a
        full dinner or just a couple of rounds. You can’t beat the location, the
        drinks are on point, and they have a tasty selection of food. What more
        could you ask for?
      </p>

      <figure className="blog-figure">
        <img
          src="/imgs/blog/breweries/tafts.png"
          alt="The front of Taft's Ale House inside an old church in OTR Cincinnati"
          loading="lazy"
        />
        <figcaption className="blog-figcaption">
          Taft’s Ale House in OTR{" "}
          <span className="blog-credit">
            • Photo: @taftsbrewingcompany on Instagram
          </span>
        </figcaption>
      </figure>

      <h2>4. Dead Low Brewing</h2>
      <p>
        If you’re going to a concert at Riverbend this year, make a pit stop just
        a half mile down the street at Dead Low. I might be a little partial to
        this place, since formerly it was a wedding venue where my husband and I
        had our reception 17 years ago. The other thing that makes me partial to
        Dead Low is their loaded nachos. <strong>ORDER THEM.</strong> You won’t
        regret it.
      </p>

      <figure className="blog-figure">
        <img
          src="/imgs/blog/breweries/dead-low.png"
          alt="Burger, hot dogs, nachos, and sides at Dead Low Brewing"
          loading="lazy"
        />
        <figcaption className="blog-figcaption">
          Food spread at Dead Low{" "}
          <span className="blog-credit">• Photo: @deadlowbrewing on Instagram</span>
        </figcaption>
      </figure>

      <div className="blog-callout">
        Want more local reads like this? Check out the rest of the blog for
        neighborhood guides, weekend ideas, and home tips.
      </div>
    </div>
  );
}
